module.exports = __webpack_public_path__ + "img/botonPinguino.cb415df1.png";